import type { WorkIssue } from '@/types/github'

/**
 * Bucket issues into a fixed, ordered set of columns. Issues whose key isn't a
 * column are dropped (callers that group by a closed set — priority, a
 * pre-filtered stage list — never produce strays; views that can, count them
 * separately, e.g. the sprint board's off-board tally).
 */
export function groupIntoColumns(
  issues: WorkIssue[],
  columns: readonly string[],
  keyOf: (issue: WorkIssue) => string,
  compare: (a: WorkIssue, b: WorkIssue) => number,
): Map<string, WorkIssue[]> {
  const map = new Map<string, WorkIssue[]>()
  for (const column of columns) map.set(column, [])
  for (const issue of issues) {
    map.get(keyOf(issue))?.push(issue)
  }
  for (const list of map.values()) list.sort(compare)
  return map
}

export function columnTotal(itemsByColumn: Map<string, WorkIssue[]>): number {
  let total = 0
  for (const list of itemsByColumn.values()) total += list.length
  return total
}
